<div [class]="'pr-button-dropdown' + (clazz ? ' ' + clazz : '')">
  <pr-button
    [class]="btnClass"
    [display]="display"
    [size]="size"
    [icon]="icon"
    [rightIcon]="expandIcon ? expandIcon : 'expand_more'"
    (onClick)="toggle()"
    [tooltip]="tooltip"
    [label]="label"
  >
  </pr-button>

  <div #dropdown class="pr-button-dropdown-content">
    <ng-content></ng-content>
  </div>
</div>
